import { Translation } from 'hooks/useTranslation/useTranslation';
import { FilterChip } from 'v2/components/SearchAndFilters/SearchAndFilters';
import { DeviceGroupsFilterState } from './deviceGroupFilterTypes';

interface Params {
  translation: Translation;
  filters: DeviceGroupsFilterState;
}

export const createDeviceGroupFilterChips = ({ translation, filters }: Params): FilterChip[] => {
  const { filterState, setFilterState } = filters;

  return [
    ...(filterState.noDevices
      ? [
          {
            label: translation.no_devices,
            onDelete: () => setFilterState((current) => ({ ...current, noDevices: false }))
          }
        ]
      : []),
    ...(filterState.noUserGroups
      ? [
          {
            label: translation.no_user_groups,
            onDelete: () => setFilterState((current) => ({ ...current, noUserGroups: false }))
          }
        ]
      : [])
  ];
};
